import { render } from "./AnimationsSweetTransitionsUglyChild.vue?vue&type=template&id=38d938f6&scoped=true&ts=true"
import script from "./AnimationsSweetTransitionsUglyChild.vue?vue&type=script&lang=ts"
export * from "./AnimationsSweetTransitionsUglyChild.vue?vue&type=script&lang=ts"

import "./AnimationsSweetTransitionsUglyChild.vue?vue&type=style&index=0&id=38d938f6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d938f6"]])

export default __exports__